import React, { ClassType, ComponentProps, ReactNode, Component, ComponentClass } from 'react';
import { Page as PdfPage, Text, View, Document as PdfDocument, Image } from '@react-pdf/renderer';
import moment from 'moment';
import Logo from '../../asset/Travelsment.png'
import ActualTime from './Common/timezone';
import Helper from '../../Helper';

// https://github.com/diegomura/react-pdf/issues/1779
// I renamed `Page` to `PdfPage` on import, and here assigning itto a variable named `Page`
// so that the code here is aligned with `react-pdf` documentation examples,
// same goes with `Document` import.
const Page: ClassType<
    ComponentProps<typeof PdfPage> & { children?: ReactNode },
    Component<ComponentProps<typeof PdfPage> & { children?: ReactNode }>,
    ComponentClass<ComponentProps<typeof PdfPage> & { children?: ReactNode }>
> = PdfPage as any;

const Document: ClassType<
    ComponentProps<typeof PdfDocument> & {
        children: ReactNode;
    },
    Component<
        ComponentProps<typeof PdfDocument> & {
            children: ReactNode;
        }
    >,
    ComponentClass<
        ComponentProps<typeof PdfDocument> & {
            children: ReactNode;
        }
    >
> = PdfDocument as any;

// const MyDocument: any = Document
// const MyPage: any = Page


const PDF_REPORT_DOCUMENT = (props: any) => {
    const { buliddata } = props;

    const Replace = (value: any) => {
        return value ? value.toString().replace('_', '-') : '';
    }

    const getHTML = (node: any) => {
        let text: any;
        if (node !== null) {
            text = node

            text = text.replaceAll("&nbsp;", "");
            text = text.replace(/<[^>]+>/g, "");

            if (text.trim() === "") {

                return false
            }
            else {
                return text
            }
        }
        else return false

    }

    const MapData = [
        {
            key: 'details',
            ketTitle: 'Day Summary',
        },
        {
            key: 'description',
            ketTitle: 'Day Details',
        },
        buliddata?.type === 'Actual' ? {
            key: 'importantInformation',
            ketTitle: 'Important Informations',
        } : null,
        buliddata?.type === 'Actual' ? {
            key: 'internalComment',
            ketTitle: 'Comment from Travelsment',
        } : null,
        {
            key: 'dayFlights',
            keyTitle: 'Flight',
            node: 'flight',
            title: 'airlineName',
            values: [
                { name: 'Record Locator', value: 'recordLocator', type: 'text', parent: "" },
                { name: 'Depart Date', value: 'departDate', type: 'date', parent: "" },
                { name: 'Depart Time', value: 'departTime', type: 'time', parent: "" },
                { name: 'Arrival Date', value: 'arrivalDate', type: 'date', parent: "" },
                { name: 'Arrival Time', value: 'arrivalTime', type: 'time', parent: "" },
                { name: 'Adults', value: 'adults', type: 'text', parent: "" },
                { name: 'Children', value: 'children', type: 'text', parent: "" },
                { name: 'Cabin Type', value: 'cabinType', type: 'text', parent: "" },
                { name: 'Flgith Number', value: 'flgithNumber', type: 'text', parent: "flight" },
                { name: 'Departure Airport', value: 'departureAirport', type: 'text', parent: "flight" },
                { name: 'Departure AirportCode', value: 'departureAirportCode', type: 'text', parent: "flight" },
                { name: 'Arrival Airport', value: 'arrivalAirport', type: 'text', parent: "flight" },
                { name: 'Arrival AirportCode', value: 'arrivalAirportCode', type: 'text', parent: "flight" },
                { name: 'Airline Name', value: 'airlineName', type: 'text', parent: "flight" }]
        }, {
            key: 'dayCarRentals',
            keyTitle: 'Car Rental',
            node: 'carRental',
            title: 'companyName',
            values: [
                { name: 'Pick Up Address', value: 'pickUpLocation', type: 'text', parent: "" },
                { name: 'Pick Up Date', value: 'pickUpDate', type: 'date', parent: "" },
                { name: 'Pick Up Time', value: 'pickUpTime', type: 'time', parent: "" },
                { name: 'Drop Off Address', value: 'dropOffLocation', type: 'text', parent: "" },
                { name: 'Drop Off Date', value: 'dropOffDate', type: 'date', parent: "" },
                { name: 'Drop Off Time', value: 'dropOffTime', type: 'time', parent: "" },
                { name: 'Paying Arrangement', value: 'payingArrangement', type: 'text', parent: "" },
                { name: 'Car Brand', value: 'carBrand', type: 'text', parent: "" },
                { name: 'Car Type', value: 'carType', type: 'text', parent: "" },
                { name: 'DateOf Booking', value: 'dateOfBooking', type: 'date', parent: "" },
                { name: 'Company Name', value: 'companyName', type: 'text', parent: "carRental" },
            ]
        }, {
            key: 'dayAccommodations',
            keyTitle: 'Check-in at ',
            node: 'accommodation',
            title: 'name',
            values: [
                { name: 'Confirmation Number', value: 'confirmationNumber', type: 'text', parent: "" },
                { name: 'Check-In Date', value: 'checkInDate', type: 'date', parent: "" },
                { name: 'Check-In Time', value: 'checkInTime', type: 'time', parent: "" },
                { name: 'Check-Out Date', value: 'checkOutDate', type: 'date', parent: "" },
                { name: 'Check-Out Time', value: 'checkOutTime', type: 'time', parent: "" },
                { name: 'Extra Request', value: 'extraRequest', type: 'text', parent: "" },
                // { name: 'Rooms', value: 'name', type: 'text', parent: "accommodationRooms" },
                { name: 'Type', value: 'type', type: 'text', parent: "accommodation" },
                { name: 'Number Of Stars', value: 'numberOfStars', type: 'text', parent: "accommodation" },
                { name: 'Description', value: 'description', type: 'text', parent: "accommodation" },
                { name: 'Phone', value: 'phone', type: 'text', parent: "accommodation" },
                { name: 'Email', value: 'email', type: 'text', parent: "accommodation" },
                { name: 'Locality', value: 'locality', type: 'text', parent: "accommodation" },
                { name: 'Address', value: 'street', type: 'address', header: true, parent: "accommodation" },
                { name: 'Street 2', value: 'street2', type: 'address', parent: "accommodation" },
                { name: 'City', value: 'city', type: 'address', parent: "accommodation" },
                { name: 'State Province', value: 'stateProvince', type: 'address', parent: "accommodation" },
                { name: 'Zip', value: 'zip', type: 'address', parent: "accommodation" },
                { name: 'Country', value: 'country', type: 'address', parent: "accommodation" },
            ]
        }, {
            key: 'dayCruises',
            keyTitle: 'Cruise',
            node: 'cruise',
            title: 'cruiseLineName',
            values: [
                { name: 'Confirmation Number', value: 'confirmationNumber', type: 'text', parent: "" },
                { name: 'Departure Date', value: 'departureDate', type: 'date', parent: "" },
                { name: 'Departure Time', value: 'departureTime', type: 'time', parent: "" },
                { name: 'Return Date', value: 'returnDate', type: 'date', parent: "" },
                { name: 'Return Time', value: 'returnTime', type: 'time', parent: "" },
                { name: 'Deck Number', value: 'deckNumber', type: 'text', parent: "" },
                { name: 'Ship Name', value: 'shipName', type: 'text', parent: "cruise" },
                { name: 'Departure Port', value: 'departurePort', type: 'text', parent: "cruise" },
                { name: 'Return Port', value: 'returnPort', type: 'text', parent: "cruise" },
                { name: 'Number Of Nights', value: 'numberOfNights', type: 'text', parent: "cruise" },
                { name: 'CruiseLine Name', value: 'cruiseLineName', type: 'text', parent: "cruise" },
                { name: 'CruiseContact Phone', value: 'cruiseContactPhone', type: 'text', parent: "cruise" },
            ]
        }, {
            key: 'dayFerries',
            keyTitle: 'Ferry',
            node: 'ferry',
            title: 'ferryCompany',
            values: [
                { name: 'Confirmation Number', value: 'confirmationNumber', type: 'text', parent: "" },
                { name: 'Depart Date', value: 'departDate', type: 'date', parent: "" },
                { name: 'Depart Time', value: 'departTime', type: 'time', parent: "" },
                { name: 'Arrival Date', value: 'arrivalDate', type: 'date', parent: "" },
                { name: 'Arrival Time', value: 'arrivalTime', type: 'time', parent: "" },
                { name: 'Class', value: 'class', type: 'text', parent: "" },
                { name: 'Adults', value: 'adults', type: 'text', parent: "" },
                { name: 'Children', value: 'children', type: 'text', parent: "" },
                { name: 'Ship Type', value: 'shipType', type: 'text', parent: "" },
                { name: 'Name', value: 'name', type: 'text', parent: "" },
                { name: 'Departure Port', value: 'departurePort', type: 'text', parent: "ferry" },
                { name: 'Arrival Port', value: 'arrivalPort', type: 'text', parent: "ferry" },
                { name: 'Ferry Company', value: 'ferryCompany', type: 'text', parent: "ferry" },
            ]
        }, {
            key: 'dayTrains',
            keyTitle: 'Train',
            node: 'train',
            title: 'trainTripName',
            values: [
                { name: 'Confirmation Number', value: 'confirmationNumber', type: 'text', parent: "" },
                { name: 'Train Number', value: 'trainNumber', type: 'text', parent: "" },
                { name: 'Depart Date', value: 'departDate', type: 'date', parent: "" },
                { name: 'Depart Time', value: 'departTime', type: 'time', parent: "" },
                { name: 'Arrival Date', value: 'arrivalDate', type: 'date', parent: "" },
                { name: 'Arrival Time', value: 'arrivalTime', type: 'time', parent: "" },
                { name: 'Car Number', value: 'carNumber', type: 'text', parent: "" },
                { name: 'Adults', value: 'adults', type: 'text', parent: "" },
                { name: 'Children', value: 'children', type: 'text', parent: "" },
                { name: 'Train Type', value: 'trainType', type: 'text', parent: "" },
                { name: 'Class', value: 'class', type: 'text', parent: "" },
                { name: 'Departure Train Station', value: 'departureTrailStation', type: 'text', parent: "train" },
                { name: 'Arrival Train Station', value: 'arrivalTrainStation', type: 'text', parent: "train" },
            ]
        }, {
            key: 'dayActivities',
            keyTitle: 'Activity',
            node: 'activity',
            title: 'name',
            values: [
                { name: 'Confirmation Number', value: 'confirmationNumber', type: 'text', parent: "" },
                { name: 'Duration Hours', value: 'durationHours', type: 'text', parent: "" },
                { name: 'Participants', value: 'participants', type: 'text', parent: "" },
                { name: 'Start Point', value: 'startPoint', type: 'text', parent: "" },
                { name: 'Start Time', value: 'startTime', type: 'time', parent: "" },
                { name: 'Adults', value: 'adults', type: 'text', parent: "" },
                { name: 'Children', value: 'children', type: 'text', parent: "" },
                { name: 'Provider', value: 'provider', type: 'text', parent: "activity" },
                { name: 'Name', value: 'name', type: 'text', parent: "activity" },
                { name: 'Description', value: 'description', type: 'text', parent: "activity" },
                { name: 'Group Type', value: 'groupType', type: 'text', parent: "activity" },
            ]
        }, {
            key: 'dayInsurances',
            keyTitle: 'Insurance',
            node: 'insurance',
            title: 'provider',
            values: [
                { name: 'Confirmation Policy Number', value: 'confirmationPolicyNumber', type: 'text', parent: "" },
                { name: 'Provider', value: 'provider', type: 'text', parent: "insurance" },
                { name: 'Plan', value: 'plan', type: 'text', parent: "insurance" },
                { name: 'State', value: 'state', type: 'text', parent: "insurance" },
            ]
        }, {
            key: 'dayTransfers',
            keyTitle: 'Transfer',
            node: 'transfer',
            title: 'providerName',
            values: [
                { name: 'Confirmation Number', value: 'confirmationNumber', type: 'text', parent: "" },
                { name: 'Transfer Date', value: 'transferDate', type: 'date', parent: "" },
                { name: 'Start Time', value: 'startTime', type: 'time', parent: "" },
                { name: 'Start Point', value: 'startPoint', type: 'text', parent: "" },
                { name: 'Finish Point', value: 'finishPoint', type: 'text', parent: "" },
                { name: 'Transfer Type', value: 'transferType', type: 'text', parent: "" },
                { name: 'Adults', value: 'adults', type: 'text', parent: "" },
                { name: 'Children', value: 'children', type: 'text', parent: "" },
                { name: 'Locality', value: 'locality', type: 'text', parent: "transfer" },
                { name: 'Provider Name', value: 'providerName', type: 'text', parent: "transfer" },
                { name: 'Provider Phone', value: 'providerPhone', type: 'text', parent: "transfer" },
                { name: 'Provider Email', value: 'providerEmail', type: 'text', parent: "transfer" },
            ]
        }, {
            key: 'dayRestaurants',
            keyTitle: 'Restaurant',
            node: 'restaurant',
            title: 'name',
            values: [
                { name: 'Confirmation Number', value: 'confirmationNumber', type: 'text', parent: "" },
                { name: 'Reservation Name', value: 'reservationName', type: 'text', parent: "" },
                { name: 'Duration Hours', value: 'durationHours', type: 'time', parent: "" },
                { name: 'Start Point', value: 'startPoint', type: 'text', parent: "" },
                { name: 'Start Time', value: 'startTime', type: 'time', parent: "" },
                { name: 'Adults', value: 'adults', type: 'text', parent: "" },
                { name: 'Children', value: 'children', type: 'text', parent: "" },
                { name: 'Name', value: 'name', type: 'text', parent: "restaurant" },
                { name: 'Pricing', value: 'pricing', type: 'text', parent: "restaurant" },
                { name: 'Cuisine', value: 'cuisine', type: 'text', parent: "restaurant" },
                { name: 'Description', value: 'description', type: 'text', parent: "restaurant" },
                { name: 'Address', value: 'address', type: 'text', parent: "restaurant" },
                { name: 'Phone', value: 'phone', type: 'text', parent: "restaurant" },
                { name: 'Email', value: 'email', type: 'text', parent: "restaurant" }
            ]
        }]
    let i: number = 0;
    return <Document>
        <Page size="A4" wrap={true} style={{ padding: '48px', fontSize: '12px' }} >
            <Image style={{ height: '30px', width: '120px' }} src={Logo} />
            <View >
                <View style={{ paddingTop: '20px', paddingBottom: '8px', borderBottom: '1px solid #aaa' }}>
                    <Text style={{ fontSize: '16px' }}>{buliddata?.name}</Text>
                    <Text style={{ fontSize: '12px', paddingTop: '4px' }}>{moment.utc(buliddata?.startDate).format("ddd MMM DD YYYY")} - {moment.utc(buliddata?.endDate).format("ddd MMM DD YYYY")}  </Text>
                </View>
                <View style={{ paddingTop: '24px', fontSize: '12px' }}>
                    {buliddata?.days ? buliddata?.days?.map((node: any, index: number) => {
                        i++;
                        return <View key={index} style={{ paddingTop: '8px' }} >
                            <Text style={{ paddingBottom: '8px', color: '#0094ff', fontWeight: 'bold' }}>Day  {i} <Text style={{ color: 'gray', fontSize: '10px' }}>[ {moment.utc(node?.date).format("ddd MMM DD YYYY")} ]</Text></Text>
                            {MapData.map((item: any, ix: number) => {

                                return <View key={ix} style={{ padding: '4px 8px' }}>
                                    {Array.isArray(node[item.key]) ? node[item.key].map((comp: any, ixx: number) => {
                                        let value;
                                        let index = 0;
                                        let add = '';
                                        return <View key={ixx} style={{ border: '2px solid #eee', marginBottom: '8px' }}>
                                            <Text style={{ fontSize: '12px', padding: '8px', color: '#0094ff' }}>{item.keyTitle} - {item.title ? comp[item.node][item.title] : ""}</Text>
                                            {item.values.map((val: any, ixxx: number) => {
                                                value = (val.parent === '' ? comp[val.value] : val.parent === 'accommodationRooms' ? comp[val.parent][0][val.value] : comp[val.parent][val.value]);
                                                value = Replace(value);
                                                add = val.type === 'address' ? add + value : ''
                                                index = value !== '' ? index + 1 : index;
                                                return value ?

                                                    <Text key={ixxx} style={{ padding: '4px', backgroundColor: index % 2 === 1 ? '#eee' : 'white' }}>

                                                        <Text style={{ color: 'gray', marginLeft: val.type === 'address' && !val.header ? '50px' : '', fontSize: '11px' }}>{
                                                            val.type !== 'address' ? val.name : val.header ? val.name : " "
                                                        }: </Text>

                                                        {val.type === 'time' ? moment(ActualTime(value)).format('hh:mm a')
                                                            : val.type === 'date' ? moment.utc(value).format("ddd MMM DD YYYY")
                                                                : value}
                                                    </Text>
                                                    : null
                                            })}
                                        </View>
                                    }) :

                                        getHTML(node[item?.key]) ? <View style={{ paddingTop: '20px', paddingBottom: '2px' }}>
                                            <Text style={{ fontSize: '12px', padding: '2px', color: '#0094ff' }}>{item?.ketTitle}</Text>
                                            <Text style={{ color: 'gray', fontSize: '11px', padding: '2px 10px' }}>{getHTML(node[item?.key])}</Text>
                                        </View> : null
                                    }

                                </View>
                            })}
                        </View>
                    }) : null}
                </View>
            </View>
        </Page>
    </Document>

}
// ReactDOM.render(<PDF_REPORT_Document />, document.getElementById('root'));

export default PDF_REPORT_DOCUMENT
// ReactDOM.render(<PdfViwer />, document.getElementById('pdfPreview'));

